import React, { Component } from 'react'

import Posts from "components/Posts/Posts" ;

export default class PostView extends Component {
  render() {
    return (
      <div>
          <Posts />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Posts/PostView.jsx